import { useSearchParams } from 'next/navigation';
import { Box, BoxComponentProps, Transition } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { parseChatTab } from '../../../_enums/chat-tab';
import { parseChatTabTarget } from '../../../_enums/chat-tab-target';
import { ChatFloatingWindow } from '../../layout/chat-popup/chat-floating-window';
import { MarketplaceCustomerChatProvider } from '../marketplace/marketplace-customer-chat-provider';
import { ChatFloatingButton } from './chat-floating-button';

const boxBaseStyle: BoxComponentProps = {
  pos: 'fixed',
  bottom: '2rem',
  right: '4rem',
};

export function ChatPopup() {
  const searchParams = useSearchParams();

  const [opened, { toggle }] = useDisclosure(false);
  const params = {
    branchId: parseInt(searchParams.get('branch_id') ?? '', 10),
    tab: parseChatTab(searchParams.get('tab') ?? ''),
    target: parseChatTabTarget(searchParams.get('target') ?? ''),
  };

  return (
    <MarketplaceCustomerChatProvider
      branchId={params.branchId}
      initialOpenedTab={params.tab}
      initialOpenedTabTarget={params.target}
    >
      <Transition
        mounted={!opened}
        transition="slide-up"
        duration={500}
        timingFunction="ease"
      >
        {(styles) => (
          <Box {...boxBaseStyle} className="z-90" style={styles}>
            <ChatFloatingButton onClick={toggle} />
          </Box>
        )}
      </Transition>

      <Transition
        mounted={opened}
        transition="slide-up"
        duration={500}
        timingFunction="ease"
      >
        {(styles) => (
          <Box {...boxBaseStyle} className="z-91" style={styles}>
            <ChatFloatingWindow onClose={toggle} />
          </Box>
        )}
      </Transition>
    </MarketplaceCustomerChatProvider>
  );
}
